// GENERATED — nicht von Hand editieren.
// Quelle: konfigurator-app.js · Build: konfigurator-tools/build-konfigurator.js
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
  createPortal
} = React;
function fabricSubLabel(fabric) {
  if (!fabric?.name) return null;
  const auto = `artikelnummer ${fabric.stoffcode}`.toLowerCase();
  return fabric.name.toLowerCase() === auto ? null : fabric.name;
}
function cdnSized(url, w) {
  if (!url || typeof url !== 'string' || url.indexOf('/cdn/shop/') === -1 || url.indexOf('width=') !== -1) return url;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
}
function SmartImg({
  src,
  fallbackSrc = null,
  alt = '',
  className = '',
  style = {},
  eager = false,
  w = 900
}) {
  const [phase, setPhase] = useState('loading');
  useEffect(() => {
    setPhase('loading');
  }, [src]);
  const effSrc = cdnSized(phase === 'error' && fallbackSrc ? fallbackSrc : src, w);
  if (!effSrc || phase === 'error' && !fallbackSrc) {
    return React.createElement("span", {
      className: `cf-img-missing ${className}`,
      "aria-hidden": "true"
    });
  }
  return React.createElement("img", {
    src: effSrc,
    alt: alt,
    loading: eager ? 'eager' : 'lazy',
    decoding: "async",
    className: `cf-smartimg${phase !== 'loading' ? ' is-loaded' : ''}${phase === 'error' ? ' is-fallback' : ''} ${className}`,
    style: style,
    onLoad: () => setPhase(p => p === 'error' ? p : 'loaded'),
    onError: () => {
      console.warn('[Konfigurator] Bild fehlt:', src);
      setPhase('error');
    }
  });
}
function ProductImg({
  type,
  variant,
  stoffcode,
  leatherColorSuffix,
  className = '',
  style = {}
}) {
  if (!type || !variant) return null;
  const d = stoffcode ? getProductDisplay(type, variant, stoffcode, {
    leatherColorSuffix
  }) : {
    src: variant.preview || variant.icon,
    image: variant.preview,
    icon: variant.icon,
    texture: null,
    textured: false
  };
  if (!d.src) return null;
  const silhouette = variant.icon || type.icon || null;
  if (d.textured) {
    return React.createElement("div", {
      className: `cf-pimg cf-pimg--textured ${className}`,
      style: {
        backgroundImage: `url("${cdnSized(d.texture, 900)}")`,
        ...style
      }
    }, React.createElement("img", {
      src: d.icon,
      alt: "",
      className: "cf-pimg__blend"
    }));
  }
  return React.createElement(SmartImg, {
    src: d.image || d.src,
    fallbackSrc: silhouette,
    className: `cf-pimg ${className}`,
    style: style
  });
}
function ZoomModal({
  src,
  title,
  onClose
}) {
  useEffect(() => {
    const onKey = e => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);
  return ReactDOM.createPortal(React.createElement("div", {
    className: "cf-zoom",
    onClick: onClose
  }, React.createElement("div", {
    className: "cf-zoom__dialog",
    onClick: e => e.stopPropagation()
  }, React.createElement("button", {
    className: "cf-zoom__close",
    onClick: onClose,
    "aria-label": "Schlie\xDFen"
  }, "\xD7"), React.createElement("p", {
    className: "cf-zoom__eyebrow"
  }, "Detailansicht"), React.createElement("h2", {
    className: "cf-zoom__title"
  }, title), React.createElement("div", {
    className: "cf-zoom__media"
  }, React.createElement("img", {
    src: cdnSized(src, 1600),
    alt: title,
    className: "cf-zoom__img"
  })))), document.body);
}
function CompareModal({
  type,
  variant,
  fabricId,
  pinnedFabrics,
  onPick,
  onUnpin,
  onClose,
  leatherColorSuffix
}) {
  useEffect(() => {
    const onKey = e => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);
  return ReactDOM.createPortal(React.createElement("div", {
    className: "cf-compare",
    onClick: onClose
  }, React.createElement("div", {
    className: "cf-compare__dialog",
    onClick: e => e.stopPropagation()
  }, React.createElement("button", {
    className: "cf-compare__close",
    onClick: onClose,
    "aria-label": "Schlie\xDFen"
  }, "\xD7"), React.createElement("div", {
    className: "cf-compare__head"
  }, React.createElement("p", {
    className: "cf-compare__eyebrow"
  }, "\u2014 Stoffvergleich"), React.createElement("h2", {
    className: "cf-compare__title"
  }, type.label, " ", variant.label), React.createElement("p", {
    className: "cf-compare__sub"
  }, pinnedFabrics.length, " Stoffe nebeneinander \xB7 klicken zum Ausw\xE4hlen")), React.createElement("div", {
    className: `cf-compare__grid cf-compare__grid--${pinnedFabrics.length}`
  }, pinnedFabrics.map(f => {
    const d = getProductDisplay(type, variant, f.stoffcode, {
      leatherColorSuffix
    });
    const isCurrent = fabricId === f.id;
    return React.createElement("button", {
      key: f.id,
      className: `cf-compare-card${isCurrent ? ' is-current' : ''}`,
      onClick: () => onPick(f.id)
    }, isCurrent && React.createElement("span", {
      className: "cf-compare-card__current"
    }, "Aktuell"), React.createElement("span", {
      className: "cf-compare-card__remove",
      onClick: e => {
        e.stopPropagation();
        onUnpin(f.id);
      },
      role: "button",
      tabIndex: 0,
      "aria-label": "Vom Vergleich entfernen"
    }, "\xD7"), React.createElement("div", {
      className: "cf-compare-card__stage"
    }, d.textured ? React.createElement("div", {
      className: "cf-pimg cf-pimg--textured cf-pimg--fill",
      style: {
        backgroundImage: `url("${cdnSized(d.texture, 900)}")`
      }
    }, React.createElement("img", {
      src: d.icon,
      alt: "",
      className: "cf-pimg__blend"
    })) : React.createElement(SmartImg, {
      src: d.image || d.src,
      fallbackSrc: variant?.icon || type?.icon,
      className: "cf-compare-card__img"
    })), React.createElement("div", {
      className: "cf-compare-card__info"
    }, React.createElement("div", {
      className: "cf-compare-card__code"
    }, f.stoffcode), fabricSubLabel(f) && React.createElement("div", {
      className: "cf-compare-card__name"
    }, fabricSubLabel(f))), React.createElement("div", {
      className: "cf-compare-card__cta"
    }, isCurrent ? 'Bereits ausgewählt' : 'Diesen Stoff auswählen →'));
  })))), document.body);
}
function StepProduct({
  typeId,
  onPick
}) {
  return React.createElement("div", {
    className: "cf-step-page"
  }, React.createElement("header", {
    className: "cf-step-head"
  }, React.createElement("div", {
    className: "cf-step-bgnum",
    "aria-hidden": "true"
  }, "01"), React.createElement("h1", null, "Was darf es werden?"), React.createElement("p", null, "Vier Produkte \u2014 jedes in der eigenen Manufaktur handgefertigt.")), React.createElement("div", {
    className: "cf-prod-grid"
  }, PRODUCT_TYPES.map(p => {
    const firstVariant = p.variants[0];
    const heroSrc = firstVariant?.preview || firstVariant?.icon || p.icon;
    const isSelected = typeId === p.id;
    return React.createElement("button", {
      key: p.id,
      className: `cf-prod ${isSelected ? 'is-selected' : ''}`,
      onClick: () => onPick(isSelected ? null : p.id)
    }, React.createElement("div", {
      className: "cf-prod-stage"
    }, heroSrc && React.createElement(SmartImg, {
      src: heroSrc,
      fallbackSrc: p.icon,
      className: "cf-prod-hero"
    })), React.createElement("div", {
      className: "cf-prod-info"
    }, React.createElement("div", {
      className: "cf-prod-name"
    }, p.label), React.createElement("div", {
      className: "cf-prod-sub"
    }, p.sub), React.createElement("div", {
      className: "cf-prod-meta"
    }, p.variants.length, " ", p.variants.length === 1 ? 'Ausführung' : 'Ausführungen', React.createElement("span", {
      className: "cf-prod-price"
    }, "ab ", fmtPrice(priceOf(p.id)), " \u20AC"))));
  })));
}
const POPULAR_VARIANT = {
  fliege: 'standard',
  krawatte: 'slim',
  hosentraeger: 'leder'
};
function defaultVariantFor(type) {
  if (!type) return null;
  const want = POPULAR_VARIANT[type.id];
  return want && type.variants.find(v => v.id === want) || type.variants.find(v => v.id === 'standard') || type.variants[0] || null;
}
function StepVariant({
  type,
  variantId,
  onPick
}) {
  if (!type) return null;
  const popularId = defaultVariantFor(type)?.id;
  return React.createElement("div", {
    className: "cf-step-page"
  }, React.createElement("header", {
    className: "cf-step-head cf-step-head--row"
  }, React.createElement("div", {
    className: "cf-step-bgnum",
    "aria-hidden": "true"
  }, "02"), React.createElement("div", null, React.createElement("div", {
    className: "cf-step-eyebrow"
  }, type.label), React.createElement("h1", null, "Welche Ausf\xFChrung?"), React.createElement("p", null, "Schnitt und Proportion bestimmen die Wirkung."))), React.createElement("div", {
    className: `cf-var-grid cf-var-grid--${type.variants.length}`
  }, type.variants.map(v => {
    const isSelected = variantId === v.id;
    return React.createElement("button", {
      key: v.id,
      className: `cf-var ${isSelected ? 'is-selected' : ''}`,
      onClick: () => onPick(isSelected ? null : v.id)
    }, React.createElement("div", {
      className: "cf-var-stage"
    }, v.id === popularId && type.variants.length > 1 && React.createElement("span", {
      className: "cf-var-badge"
    }, "Beliebteste Wahl"), v.preview ? React.createElement(SmartImg, {
      src: v.preview,
      fallbackSrc: v.icon,
      className: "cf-var-img"
    }) : v.icon && React.createElement(SmartImg, {
      src: v.icon,
      className: "cf-var-img cf-var-img--icon"
    })), React.createElement("div", {
      className: "cf-var-info"
    }, React.createElement("div", {
      className: "cf-var-name"
    }, v.label), React.createElement("div", {
      className: "cf-var-desc"
    }, v.desc), React.createElement("div", {
      className: "cf-var-price"
    }, fmtPrice(priceOf(type.id, v.id)), " \u20AC")));
  })));
}
function StepFabric({
  type,
  variant,
  fabric,
  fabricId,
  onPick,
  leatherColorSuffix
}) {
  const [activeMuster, setActiveMuster] = useState(null);
  const [zoom, setZoom] = useState(null);
  const counts = useMemo(() => ({
    alle: FABRICS.length,
    uni: FABRICS.filter(f => f.muster === 'uni').length,
    gemustert: FABRICS.filter(f => f.muster === 'gemustert').length
  }), []);
  const filtered = useMemo(() => activeMuster ? FABRICS.filter(f => f.muster === activeMuster) : FABRICS, [activeMuster]);
  if (!type || !variant) return null;
  const display = fabric ? getProductDisplay(type, variant, fabric.stoffcode, {
    leatherColorSuffix
  }) : null;
  return React.createElement("div", {
    className: "cf-fab-layout"
  }, React.createElement("div", {
    className: "cf-hero"
  }, React.createElement("button", {
    className: "cf-hero-stage",
    onClick: () => display?.src && setZoom({
      src: display.src,
      title: `${type.label} ${variant.label}${fabric ? ` · Stoff ${fabric.stoffcode}` : ''}`
    }),
    disabled: !display?.src,
    "aria-label": "Produktbild vergr\xF6\xDFern"
  }, display ? display.textured ? React.createElement("div", {
    className: "cf-pimg cf-pimg--textured cf-pimg--fill",
    style: {
      backgroundImage: `url("${cdnSized(display.texture, 900)}")`
    }
  }, React.createElement("img", {
    src: display.icon,
    alt: "",
    className: "cf-pimg__blend"
  })) : React.createElement(SmartImg, {
    src: display.image || display.src,
    fallbackSrc: variant?.icon || type?.icon,
    className: "cf-hero-img",
    eager: true
  }) : React.createElement(SmartImg, {
    src: variant?.preview || variant?.icon || type?.icon,
    className: "cf-hero-img cf-hero-img--silhouette",
    eager: true
  })), React.createElement("div", {
    className: "cf-hero-info"
  }, React.createElement("div", {
    className: "cf-hero-eyebrow"
  }, type.label, " \xB7 ", variant.label), fabric ? React.createElement(React.Fragment, null, React.createElement("div", {
    className: "cf-hero-code"
  }, fabric.stoffcode), fabricSubLabel(fabric) && React.createElement("div", {
    className: "cf-hero-name"
  }, fabricSubLabel(fabric)), React.createElement("div", {
    className: "cf-hero-hint"
  }, "Klicken f\xFCr Gro\xDFansicht")) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "cf-hero-code cf-hero-code--empty"
  }, "\u2014 \u2014"), React.createElement("div", {
    className: "cf-hero-name"
  }, "W\xE4hle aus ", FABRICS.length, " Stoffen")))), React.createElement("div", {
    className: "cf-browser"
  }, React.createElement("div", {
    className: "cf-browser-head"
  }, React.createElement("div", {
    className: "cf-browser-title"
  }, "Stoff-Bibliothek"), React.createElement("div", {
    className: "cf-browser-count"
  }, filtered.length, " Stoffe")), React.createElement("p", {
    className: "cf-screen-note"
  }, React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "14",
    height: "14",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.6",
    "aria-hidden": "true"
  }, React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), React.createElement("path", {
    d: "M12 8h.01M12 11v5"
  })), "Farbdarstellung kann je nach Bildschirm leicht abweichen \u2014 im Zweifel zeigen wir dir den Stoff gern im Gesch\xE4ft."), React.createElement("div", {
    className: "cf-fab-tabs"
  }, [[null, `Alle (${counts.alle})`], ['uni', `Uni (${counts.uni})`], ['gemustert', `Gemustert (${counts.gemustert})`]].map(([m, label]) => React.createElement("button", {
    key: m === null ? 'alle' : m,
    className: `cf-pill${activeMuster === m ? ' is-active' : ''}`,
    onClick: () => setActiveMuster(m)
  }, label))), React.createElement("div", {
    className: "cf-fab-grid"
  }, filtered.map(f => {
    const isSelected = fabricId === f.id;
    return React.createElement("button", {
      key: f.id,
      className: `cf-fab ${isSelected ? 'is-selected' : ''}`,
      onClick: () => onPick(isSelected ? null : f.id)
    }, React.createElement("span", {
      className: "cf-fab-zoom",
      role: "button",
      tabIndex: 0,
      "aria-label": `Stoff ${f.stoffcode} vergrößern`,
      title: "Stoff vergr\xF6\xDFern",
      onClick: e => {
        e.stopPropagation();
        setZoom({
          src: f.bild,
          title: `Stoff ${f.stoffcode}`
        });
      },
      onKeyDown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.stopPropagation();
          e.preventDefault();
          setZoom({
            src: f.bild,
            title: `Stoff ${f.stoffcode}`
          });
        }
      }
    }, "\u2315"), React.createElement("div", {
      className: "cf-fab-swatch"
    }, React.createElement(SmartImg, {
      src: fabricThumb(f.bild),
      fallbackSrc: f.bild,
      alt: `Stoff ${f.stoffcode}`,
      className: "cf-fab-swatch-img"
    })), React.createElement("div", {
      className: "cf-fab-meta"
    }, React.createElement("div", {
      className: "cf-fab-code"
    }, f.stoffcode)), isSelected && React.createElement("div", {
      className: "cf-fab-tick"
    }, "\u2713"));
  }), !filtered.length && React.createElement("div", {
    className: "cf-empty"
  }, "Keine Treffer"))), zoom && React.createElement(ZoomModal, {
    src: zoom.src,
    title: zoom.title,
    onClose: () => setZoom(null)
  }));
}
function StepBegleiter({
  type,
  variant,
  fabric,
  accessories,
  onSetQty,
  mainQty,
  onSetMainQty,
  leatherColorSuffix,
  accLeatherColors = {},
  onSetAccLeatherColor,
  legalOk = false,
  onLegalOk,
  onAddSameModel,
  onAddOther,
  onCompanionOtherFabric
}) {
  if (!type || !variant || !fabric) return null;
  const display = getProductDisplay(type, variant, fabric.stoffcode, {
    leatherColorSuffix
  });
  const [zoom, setZoom] = useState(null);
  const accColorSuffix = accId => {
    const cid = accLeatherColors[accId];
    return (LEATHER_COLORS || []).find(c => c.id === cid)?.suffix || null;
  };
  const related = useMemo(() => {
    return PRODUCT_TYPES.flatMap((pt, ti) => pt.variants.map((pv, vi) => {
      if (pt.id === type.id && pv.id === variant.id) return null;
      const accId = `${pt.id}:${pv.id}`;
      const isLeder = pt.id === 'hosentraeger' && pv.id === 'leder';
      const colorSuf = isLeder ? accColorSuffix(accId) || 'ck' : null;
      const d = getProductDisplay(pt, pv, fabric.stoffcode, {
        preferTextured: true,
        leatherColorSuffix: colorSuf
      });
      return {
        id: accId,
        label: `${pt.label} ${pv.label}`,
        type: pt,
        variant: pv,
        display: d,
        price: priceOf(pt.id, pv.id),
        isLeder,
        sortKey: `${pt.id === type.id ? '0' : '1'}-${ti}-${vi}`
      };
    })).filter(Boolean).sort((a, b) => a.sortKey.localeCompare(b.sortKey));
  }, [type, variant, fabric, accLeatherColors]);
  return React.createElement("div", {
    className: "cf-step-page"
  }, React.createElement("div", {
    className: "cf-hero cf-hero--bgl"
  }, React.createElement("button", {
    className: "cf-hero-stage",
    onClick: () => display?.src && setZoom({
      src: display.src,
      title: `${type.label} ${variant.label} · Stoff ${fabric.stoffcode}`
    }),
    disabled: !display?.src,
    "aria-label": "Gro\xDFansicht"
  }, display.textured ? React.createElement("div", {
    className: "cf-pimg cf-pimg--textured cf-pimg--fill",
    style: {
      backgroundImage: `url("${cdnSized(display.texture, 900)}")`
    }
  }, React.createElement("img", {
    src: display.icon,
    alt: "",
    className: "cf-pimg__blend"
  })) : React.createElement(SmartImg, {
    src: display.image || display.src,
    fallbackSrc: variant?.icon || type?.icon,
    className: "cf-hero-img",
    eager: true
  })), React.createElement("div", {
    className: "cf-hero-info"
  }, React.createElement("div", {
    className: "cf-hero-eyebrow"
  }, type.label, " \xB7 ", variant.label), React.createElement("div", {
    className: "cf-hero-code"
  }, fabric.stoffcode), fabricSubLabel(fabric) && React.createElement("div", {
    className: "cf-hero-name"
  }, fabricSubLabel(fabric)))), React.createElement("div", {
    className: "cf-bgl-product"
  }, React.createElement("button", {
    className: "cf-bgl-stage",
    onClick: () => display?.src && setZoom({
      src: display.src,
      title: `${type.label} ${variant.label} · Stoff ${fabric.stoffcode}`
    }),
    disabled: !display?.src,
    "aria-label": "Gro\xDFansicht"
  }, display.textured ? React.createElement("div", {
    className: "cf-pimg cf-pimg--textured cf-pimg--fill",
    style: {
      backgroundImage: `url("${cdnSized(display.texture, 900)}")`
    }
  }, React.createElement("img", {
    src: display.icon,
    alt: "",
    className: "cf-pimg__blend"
  })) : React.createElement(SmartImg, {
    src: display.image || display.src,
    fallbackSrc: variant?.icon || type?.icon,
    className: "cf-bgl-img",
    eager: true
  })), React.createElement("div", {
    className: "cf-bgl-product-info"
  }, React.createElement("div", {
    className: "cf-bgl-eyebrow"
  }, "Hauptprodukt"), React.createElement("h1", {
    className: "cf-bgl-title"
  }, type.label, " ", variant.label), React.createElement("div", {
    className: "cf-bgl-meta"
  }, "Stoff ", fabric.stoffcode, fabricSubLabel(fabric) ? ` · ${fabricSubLabel(fabric)}` : ''), React.createElement("div", {
    className: "cf-rev-swatch-row"
  }, React.createElement("img", {
    src: fabric.bild,
    alt: `Stoff ${fabric.stoffcode}`,
    className: "cf-rev-swatch"
  }), React.createElement("div", null, React.createElement("div", {
    className: "cf-rev-swatch-code"
  }, fabric.stoffcode), fabricSubLabel(fabric) && React.createElement("div", {
    className: "cf-rev-swatch-name"
  }, fabricSubLabel(fabric)))), React.createElement("div", {
    className: "cf-rev-spec"
  }, React.createElement("div", null, React.createElement("span", null, "Material"), React.createElement("strong", null, "Polyester 100 %"))), React.createElement("div", {
    className: "cf-bgl-qty-row"
  }, React.createElement("span", {
    className: "cf-bgl-qty-label"
  }, "St\xFCckzahl"), React.createElement("div", {
    className: "cf-qty"
  }, React.createElement("button", {
    className: "cf-qty-btn",
    onClick: () => onSetMainQty(-1),
    disabled: mainQty <= 1,
    "aria-label": "Weniger"
  }, "\u2212"), React.createElement("span", {
    className: "cf-qty-val"
  }, mainQty), React.createElement("button", {
    className: "cf-qty-btn",
    onClick: () => onSetMainQty(+1),
    "aria-label": "Mehr"
  }, "+"))))), React.createElement("div", {
    className: "cf-bgl-acc-section"
  }, React.createElement("div", {
    className: "cf-bgl-acc-eyebrow"
  }, "Optional"), React.createElement("h2", {
    className: "cf-bgl-acc-h2"
  }, "Passende Begleiter"), React.createElement("p", {
    className: "cf-bgl-acc-lead"
  }, "Stilvoll abgestimmte Produkte im selben Stoff \u2014 kein Aufpreis auf den Stoff."), React.createElement("p", {
    className: "cf-legal-note"
  }, "Konfigurierte Produkte werden eigens f\xFCr dich gefertigt. Daher sind unsere Ma\xDFanfertigungen vom gesetzlichen Widerrufsrecht ausgeschlossen. Auf unsere Qualit\xE4t kannst du dich dennoch verlassen: Material- oder Fertigungsfehler beheben wir selbstverst\xE4ndlich unkompliziert."), React.createElement("div", {
    className: "cf-acc-grid cf-acc-grid--4col"
  }, related.slice(0, 8).map(a => {
    const qty = accessories[a.id] || 0;
    const selectedLederId = a.isLeder ? accLeatherColors[a.id] || 'schwarz' : null;
    const stoffcodeForImg = fabric.stoffcode;
    const colorSufForImg = a.isLeder ? (LEATHER_COLORS || []).find(c => c.id === selectedLederId)?.suffix || 'ck' : null;
    return React.createElement("div", {
      key: a.id,
      className: `cf-acc${qty > 0 ? ' is-selected' : ''}${a.isLeder ? ' has-leder' : ''}`,
      role: "button",
      tabIndex: 0,
      "aria-pressed": qty > 0,
      onClick: () => onSetQty(a.id, qty === 0 ? +1 : -qty),
      onKeyDown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSetQty(a.id, qty === 0 ? +1 : -qty);
        }
      }
    }, React.createElement("div", {
      className: "cf-acc-stage"
    }, React.createElement(ProductImg, {
      type: a.type,
      variant: a.variant,
      stoffcode: stoffcodeForImg,
      leatherColorSuffix: colorSufForImg,
      className: "cf-acc-img"
    })), React.createElement("div", {
      className: "cf-acc-body"
    }, React.createElement("div", {
      className: "cf-acc-info"
    }, React.createElement("div", {
      className: "cf-acc-name"
    }, a.label), React.createElement("div", {
      className: "cf-acc-meta"
    }, "+ ", fmtPrice(a.price), " \u20AC"), onCompanionOtherFabric && React.createElement("button", {
      type: "button",
      className: "cf-acc-otherfabric",
      onClick: e => {
        e.stopPropagation();
        onCompanionOtherFabric(a.type, a.variant);
      },
      title: "Dieses Produkt mit einem anderen Stoff gestalten"
    }, "im anderen Stoff")), React.createElement("div", {
      className: "cf-acc-actionrow"
    }, qty > 0 && React.createElement("div", {
      className: "cf-acc-stepper",
      onClick: e => e.stopPropagation()
    }, React.createElement("button", {
      className: "cf-qty-btn",
      onClick: () => onSetQty(a.id, -1),
      "aria-label": "Weniger"
    }, "\u2212"), React.createElement("span", {
      key: qty,
      className: "cf-acc-qty-val"
    }, qty), React.createElement("button", {
      className: "cf-qty-btn",
      onClick: () => onSetQty(a.id, +1),
      "aria-label": "Mehr"
    }, "+")), a.isLeder && React.createElement("div", {
      className: "cf-acc-leder-row",
      role: "radiogroup",
      "aria-label": "Lederfarbe",
      onClick: e => e.stopPropagation()
    }, (LEATHER_COLORS || []).map(c => {
      const active = c.id === selectedLederId;
      return React.createElement("button", {
        key: c.id,
        type: "button",
        className: `cf-acc-leder-dot${active ? ' is-active' : ''}`,
        style: {
          background: c.hex
        },
        onClick: e => {
          e.stopPropagation();
          onSetAccLeatherColor?.(a.id, c.id);
        },
        "aria-label": `Lederfarbe ${c.label}`,
        "aria-pressed": active,
        title: c.label
      });
    })))));
  }), (onAddSameModel || onAddOther) && React.createElement("div", {
    className: "cf-acc-cta"
  }, React.createElement("div", {
    className: "cf-acc-cta-eyebrow"
  }, "Noch etwas dazu?"), React.createElement("div", {
    className: "cf-acc-cta-text"
  }, "Ein weiteres St\xFCck in einem anderen Stoff? Dein aktuelles St\xFCck wird gespeichert."), React.createElement("div", {
    className: "cf-acc-cta-actions"
  }, onAddSameModel && React.createElement("button", {
    type: "button",
    className: "cf-acc-cta-btn",
    onClick: onAddSameModel
  }, "Gleiches Modell, anderer Stoff"), onAddOther && React.createElement("button", {
    type: "button",
    className: "cf-acc-cta-btn cf-acc-cta-btn--ghost",
    onClick: onAddOther
  }, "Ganz anderes Produkt"))))), onLegalOk && React.createElement("label", {
    className: `cf-legal-check cf-legal-check--step${legalOk ? ' is-checked' : ''}`
  }, React.createElement("input", {
    type: "checkbox",
    checked: legalOk,
    onChange: e => onLegalOk(e.target.checked)
  }), React.createElement("span", null, "Mir ist bekannt, dass individuell angefertigte Manufaktur-Produkte vom gesetzlichen Widerrufsrecht ausgeschlossen sind (\xA7 312g Abs. 2 Nr. 1 BGB).")), zoom && React.createElement(ZoomModal, {
    src: zoom.src,
    title: zoom.title,
    onClose: () => setZoom(null)
  }));
}
const StepReview = StepBegleiter;
function ProductThumb({
  type,
  variant,
  stoffcode,
  textured,
  texture,
  icon,
  src
}) {
  if (textured) {
    return React.createElement("div", {
      className: "cf-pimg cf-pimg--textured cf-pimg--fill",
      style: {
        backgroundImage: `url("${texture}")`,
        width: '100%',
        height: '100%'
      }
    }, React.createElement("img", {
      src: icon,
      alt: "",
      className: "cf-pimg__blend"
    }));
  }
  return React.createElement(SmartImg, {
    src: src,
    fallbackSrc: icon,
    alt: `${type?.label || ''} ${variant?.label || ''}`,
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }
  });
}
function SummaryRow({
  item,
  isActive,
  onSelect,
  onDelete
}) {
  const {
    type,
    variant,
    fabric,
    accessories,
    mainQty = 1,
    leatherColor,
    accLeatherColors = {}
  } = item;
  const display = getProductDisplay(type, variant, fabric.stoffcode, {
    leatherColorSuffix: leatherColor?.suffix
  });
  const price = priceFor(type.id, accessories, mainQty, variant?.id);
  const accImages = Object.entries(accessories || {}).filter(([, qty]) => qty > 0).map(([id, qty]) => {
    const [tid, vid] = id.split(':');
    const t = PRODUCT_TYPES.find(x => x.id === tid);
    const v = t?.variants.find(x => x.id === vid);
    if (!t || !v) return null;
    const isLeder = tid === 'hosentraeger' && vid === 'leder';
    const accColor = isLeder ? (LEATHER_COLORS || []).find(c => c.id === (accLeatherColors[id] || 'schwarz')) : null;
    const d = getProductDisplay(t, v, fabric.stoffcode, {
      preferTextured: true,
      leatherColorSuffix: accColor?.suffix
    });
    const lbl = accColor ? `${t.label} ${v.label} · ${accColor.label}` : `${t.label} ${v.label}`;
    return {
      id,
      qty,
      label: lbl,
      display: d
    };
  }).filter(Boolean);
  const accText = accImages.map(a => a.qty > 1 ? `${a.qty}× ${a.label}` : a.label).join(', ');
  return React.createElement("div", {
    className: `cf-sum-row-item${isActive ? ' is-active' : ''}`,
    onClick: onSelect,
    role: "button",
    tabIndex: 0,
    onKeyDown: e => e.key === 'Enter' && onSelect?.()
  }, React.createElement("button", {
    className: "cf-summary-delete",
    onClick: e => {
      e.stopPropagation();
      onDelete?.();
    },
    "aria-label": "L\xF6schen",
    title: "Set entfernen"
  }, "\xD7"), React.createElement("div", {
    className: "cf-sum-row-info"
  }, React.createElement("div", {
    className: "cf-sum-row-name"
  }, mainQty > 1 ? `${mainQty}× ` : '', type.label, " ", variant.label), React.createElement("div", {
    className: "cf-sum-row-fabric"
  }, fabric.stoffcode, fabricSubLabel(fabric) ? ` · ${fabricSubLabel(fabric)}` : ''), leatherColor && React.createElement("div", {
    className: "cf-sum-row-fabric"
  }, "Leder: ", leatherColor.label), accText && React.createElement("div", {
    className: "cf-sum-row-acc"
  }, accText), React.createElement("div", {
    className: "cf-sum-row-price"
  }, fmtPrice(price), " \u20AC")), React.createElement("div", {
    className: "cf-sum-row-images"
  }, React.createElement("div", {
    className: "cf-sum-row-img-wrap cf-sum-row-img-wrap--main"
  }, React.createElement(ProductThumb, _extends({}, display, {
    type: type,
    variant: variant
  })), mainQty > 1 && React.createElement("div", {
    className: "cf-sum-row-img-qty"
  }, mainQty, "\xD7")), accImages.map(a => React.createElement("div", {
    key: a.id,
    className: "cf-sum-row-img-wrap"
  }, React.createElement(ProductThumb, a.display), a.qty > 1 && React.createElement("div", {
    className: "cf-sum-row-img-qty"
  }, a.qty, "\xD7")))));
}
function StepLederColor({
  type,
  variant,
  fabric,
  leatherColorId,
  onPick
}) {
  if (!type || !variant || !fabric) return null;
  const colors = LEATHER_COLORS || [];
  const selected = colors.find(c => c.id === leatherColorId) || colors[0];
  const display = selected ? getProductDisplay(type, variant, fabric.stoffcode, {
    leatherColorSuffix: selected.suffix
  }) : null;
  return React.createElement("div", {
    className: "cf-step-page"
  }, React.createElement("header", {
    className: "cf-step-head cf-step-head--row"
  }, React.createElement("div", {
    className: "cf-step-bgnum",
    "aria-hidden": "true"
  }, "04"), React.createElement("div", null, React.createElement("div", {
    className: "cf-step-eyebrow"
  }, type.label, " \xB7 ", variant.label, " \xB7 Stoff ", fabric.stoffcode), React.createElement("h1", null, "Welche Lederfarbe?"), React.createElement("p", null, "W\xE4hle das Leder f\xFCr die Patten und Riemen."))), React.createElement("div", {
    className: "cf-leder-layout"
  }, React.createElement("div", {
    className: "cf-leder-preview"
  }, display && (display.textured ? React.createElement("div", {
    className: "cf-pimg cf-pimg--textured cf-pimg--fill",
    style: {
      backgroundImage: `url("${cdnSized(display.texture, 900)}")`
    }
  }, React.createElement("img", {
    src: display.icon,
    alt: "",
    className: "cf-pimg__blend"
  })) : React.createElement(SmartImg, {
    src: display.image || display.src,
    fallbackSrc: variant?.icon || type?.icon,
    alt: `${type.label} ${variant.label} – ${selected?.label}`,
    className: "cf-leder-preview-img",
    eager: true
  }))), React.createElement("div", {
    className: "cf-leder-choices"
  }, colors.map(c => {
    const isActive = c.id === leatherColorId;
    return React.createElement("button", {
      key: c.id,
      className: `cf-leder ${isActive ? 'is-selected' : ''}`,
      onClick: () => onPick(c.id),
      type: "button"
    }, React.createElement("div", {
      className: "cf-leder-swatch",
      style: {
        background: c.hex
      }
    }, c.swatch && React.createElement("img", {
      src: c.swatch,
      alt: "",
      className: "cf-leder-swatch-img"
    })), React.createElement("div", {
      className: "cf-leder-info"
    }, React.createElement("div", {
      className: "cf-leder-name"
    }, c.label), React.createElement("div", {
      className: "cf-leder-meta"
    }, isActive ? 'Ausgewählt' : 'Auswählen')), isActive && React.createElement("div", {
      className: "cf-leder-tick"
    }, "\u2713"));
  }))));
}
function StepSummary({
  allItems,
  activeIdx,
  onSelect,
  onDelete,
  onAddAnother
}) {
  const total = allItems.reduce((s, item) => s + priceFor(item.type.id, item.accessories, item.mainQty || 1, item.variant?.id), 0);
  return React.createElement("div", {
    className: "cf-step-page"
  }, React.createElement("header", {
    className: "cf-step-head"
  }, React.createElement("div", {
    className: "cf-step-bgnum",
    "aria-hidden": "true"
  }, "05"), React.createElement("h1", null, "Deine Zusammenfassung"), React.createElement("p", null, allItems.length, " ", allItems.length === 1 ? 'Artikel' : 'Artikel', " \xB7 ", fmtPrice(total), " \u20AC")), React.createElement("div", {
    className: "cf-summary-list"
  }, allItems.map((item, i) => React.createElement(SummaryRow, {
    key: i,
    item: item,
    isActive: i === activeIdx,
    onSelect: () => onSelect(i),
    onDelete: () => onDelete(i)
  })), React.createElement("button", {
    className: "cf-sum-row-add",
    onClick: onAddAnother
  }, React.createElement("span", {
    className: "cf-sum-row-add-icon"
  }, "+"), React.createElement("span", null, "Weiteres Produkt hinzuf\xFCgen"))));
}
function SumRow({
  label,
  value,
  sub,
  swatch,
  empty,
  small,
  onEdit
}) {
  return React.createElement("div", {
    className: `cf-sum-row ${value ? 'is-filled' : ''} ${small ? 'is-small' : ''}`
  }, React.createElement("div", {
    className: "cf-sum-label"
  }, label, value && onEdit && React.createElement("button", {
    className: "cf-sum-edit",
    onClick: onEdit,
    type: "button"
  }, "\xE4ndern")), React.createElement("div", {
    className: "cf-sum-value"
  }, swatch && React.createElement("img", {
    src: swatch,
    alt: "",
    className: "cf-sum-swatch"
  }), React.createElement("span", null, value || empty)), sub && React.createElement("div", {
    className: "cf-sum-sub"
  }, sub));
}
function Trust({
  line
}) {
  return React.createElement("div", {
    className: "cf-trust-row"
  }, React.createElement("span", {
    className: "cf-trust-tick"
  }), line);
}
function Toast({
  message,
  variant = 'ok',
  action,
  onDone
}) {
  useEffect(() => {
    const t = setTimeout(onDone, action ? 6000 : 3500);
    return () => clearTimeout(t);
  }, []);
  return ReactDOM.createPortal(React.createElement("div", {
    className: `cf-toast cf-toast--${variant}`,
    role: "status",
    "aria-live": "polite"
  }, React.createElement("span", {
    className: "cf-toast__check",
    "aria-hidden": "true"
  }, variant === 'warn' ? '⚠' : '✓'), React.createElement("span", {
    className: "cf-toast__msg"
  }, message), action && React.createElement("a", {
    className: "cf-toast__action",
    href: action.href
  }, action.label)), document.body);
}
const PERSIST_KEY = 'vp_konfigurator_v1';
const PERSIST_TTL = 14 * 24 * 60 * 60 * 1000;
function persistRead() {
  try {
    const raw = window.localStorage.getItem(PERSIST_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return null;
    if (!data.savedAt || Date.now() - data.savedAt > PERSIST_TTL) {
      window.localStorage.removeItem(PERSIST_KEY);
      return null;
    }
    return data;
  } catch (_) {
    return null;
  }
}
function persistWrite(payload) {
  try {
    window.localStorage.setItem(PERSIST_KEY, JSON.stringify({
      ...payload,
      savedAt: Date.now()
    }));
  } catch (_) {}
}
function persistClear() {
  try {
    window.localStorage.removeItem(PERSIST_KEY);
  } catch (_) {}
}
function dehydrateItem(item) {
  return {
    typeId: item.type?.id || null,
    variantId: item.variant?.id || null,
    stoffcode: item.fabric?.stoffcode || null,
    accessories: item.accessories || {},
    accLeatherColors: item.accLeatherColors || {},
    mainQty: item.mainQty || 1,
    leatherColorId: item.leatherColor?.id || null
  };
}
function rehydrateItem(d) {
  const t = PRODUCT_TYPES.find(x => x.id === d.typeId);
  const v = t?.variants.find(x => x.id === d.variantId);
  const f = FABRICS.find(x => x.stoffcode === d.stoffcode);
  if (!t || !v || !f) return null;
  return {
    type: t,
    variant: v,
    fabric: f,
    accessories: d.accessories || {},
    accLeatherColors: d.accLeatherColors || {},
    mainQty: d.mainQty || 1,
    leatherColor: d.leatherColorId ? (LEATHER_COLORS || []).find(c => c.id === d.leatherColorId) || null : null
  };
}
function AnimatedPct({
  value
}) {
  const [shown, setShown] = useState(value);
  const shownRef = useRef(value);
  const rafRef = useRef(null);
  useEffect(() => {
    const from = shownRef.current;
    const to = value;
    if (from === to) return;
    const t0 = performance.now();
    const dur = 500;
    cancelAnimationFrame(rafRef.current);
    const tick = t => {
      const p = Math.min(1, (t - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      const v = Math.round(from + (to - from) * eased);
      shownRef.current = v;
      setShown(v);
      if (p < 1) rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value]);
  return React.createElement("em", {
    className: "cf-progress__pct"
  }, shown, "%");
}
function ConfiguratorApp() {
  const [step, setStep] = useState(1);
  const [typeId, setTypeId] = useState(null);
  const [variantId, setVariantId] = useState(null);
  const [fabricId, setFabricId] = useState(null);
  const [accessories, setAccessories] = useState({});
  const [mainQty, setMainQty] = useState(1);
  const [cart, setCart] = useState([]);
  const [step5ActiveIdx, setStep5ActiveIdx] = useState(null);
  const [toast, setToast] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [leatherColorId, setLeatherColorId] = useState('schwarz');
  const [accLeatherColors, setAccLeatherColors] = useState({});
  function setAccessoryLeatherColor(accId, colorId) {
    setAccLeatherColors(prev => ({
      ...prev,
      [accId]: colorId
    }));
  }
  function lookupLederColor(id) {
    return (LEATHER_COLORS || []).find(c => c.id === id) || null;
  }
  const [resumeDraft, setResumeDraft] = useState(() => {
    const d = persistRead();
    return d && (d.current?.typeId || (d.cart || []).length) ? d : null;
  });
  function applyResumeDraft() {
    const d = resumeDraft;
    if (!d) return;
    const restoredCart = (d.cart || []).map(rehydrateItem).filter(Boolean);
    setCart(restoredCart);
    const cur = d.current || {};
    const t = PRODUCT_TYPES.find(x => x.id === cur.typeId) || null;
    const v = t?.variants.find(x => x.id === cur.variantId) || null;
    const f = FABRICS.find(x => x.stoffcode === cur.stoffcode) || null;
    setTypeId(t ? t.id : null);
    setVariantId(v ? v.id : null);
    setFabricId(f ? f.id : null);
    setAccessories(cur.accessories || {});
    setAccLeatherColors(cur.accLeatherColors || {});
    setMainQty(cur.mainQty || 1);
    if (cur.leatherColorId) setLeatherColorId(cur.leatherColorId);
    let target = 1;
    if (t) target = 2;
    if (t && v) target = 3;
    if (t && v && f) target = t.id === 'hosentraeger' && v.id === 'leder' ? 4 : 4;
    if (restoredCart.length && !t) target = 1;
    setStep(d.step && d.step <= 3 ? d.step : target);
    setResumeDraft(null);
  }
  function dismissResumeDraft() {
    persistClear();
    setResumeDraft(null);
  }
  const [pinned, setPinned] = useState([]);
  const [compareOpen, setCompareOpen] = useState(false);
  function togglePin(id) {
    setPinned(prev => {
      if (prev.includes(id)) return prev.filter(x => x !== id);
      if (prev.length >= 3) return prev;
      return [...prev, id];
    });
  }
  function unpin(id) {
    setPinned(prev => prev.filter(x => x !== id));
  }
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.matchMedia('(max-width: 1023px)').matches);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [legalOk, setLegalOk] = useState(false);
  useEffect(() => {
    setDrawerOpen(false);
  }, [step]);
  useEffect(() => {
    const nav = document.querySelector('.cf-nav');
    if (nav) document.documentElement.style.setProperty('--cf-nav-h', nav.offsetHeight + 'px');
  }, [isMobile, step]);
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1023px)');
    const onChange = () => {
      setIsMobile(mq.matches);
      if (!mq.matches) setDrawerOpen(false);
    };
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  useEffect(() => {
    setDrawerOpen(false);
    setCompareOpen(false);
    const cfSection = document.querySelector('.manufaktur-konfigurator-section');
    if (cfSection) {
      const top = cfSection.getBoundingClientRect().top + window.scrollY;
      if (window.scrollY > top) window.scrollTo({
        top: top,
        behavior: 'auto'
      });
    } else {
      window.scrollTo(0, 0);
    }
    const main = document.querySelector('.cf-main');
    if (main) main.scrollTop = 0;
  }, [step]);
  useEffect(() => {
    const measure = () => {
      const h = document.querySelector('.header--sticky');
      document.documentElement.style.setProperty('--cf-sticky-offset', h ? `${h.offsetHeight}px` : '0px');
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);
  const type = useMemo(() => PRODUCT_TYPES.find(t => t.id === typeId) || null, [typeId]);
  const variant = useMemo(() => type?.variants.find(v => v.id === variantId) || null, [type, variantId]);
  const fabric = useMemo(() => FABRICS.find(f => f.id === fabricId) || null, [fabricId]);
  const isLederFlow = type?.id === 'hosentraeger' && variant?.id === 'leder';
  const leatherColor = useMemo(() => (LEATHER_COLORS || []).find(c => c.id === leatherColorId) || (LEATHER_COLORS || [])[0] || null, [leatherColorId]);
  const leatherSuffix = leatherColor?.suffix || null;
  const STEP_LABELS = isLederFlow ? ['Produkt', 'Ausführung', 'Stoff', 'Lederfarbe', 'Begleiter'] : ['Produkt', 'Ausführung', 'Stoff', 'Begleiter'];
  const totalSteps = STEP_LABELS.length;
  const summaryStep = totalSteps + 1;
  const begleiterStep = totalSteps;
  const lederStep = isLederFlow ? 4 : null;
  const canNext = step === 1 && typeId || step === 2 && variantId || step === 3 && fabricId || step === lederStep || step === begleiterStep || step === summaryStep;
  useEffect(() => {
    if (resumeDraft) return;
    const hasContent = typeId || cart.length > 0;
    if (!hasContent) {
      persistClear();
      return;
    }
    persistWrite({
      step,
      current: {
        typeId,
        variantId,
        stoffcode: fabric?.stoffcode || null,
        accessories,
        accLeatherColors,
        mainQty,
        leatherColorId
      },
      cart: cart.map(dehydrateItem)
    });
  }, [resumeDraft, step, typeId, variantId, fabric, accessories, accLeatherColors, mainQty, leatherColorId, cart]);
  useEffect(() => {
    if (step > begleiterStep) setStep(begleiterStep);
  }, [step, begleiterStep]);
  const autoDefaulted = useRef(null);
  useEffect(() => {
    if (step === 2 && type && !variantId && autoDefaulted.current !== type.id) {
      const def = defaultVariantFor(type);
      if (def) {
        autoDefaulted.current = type.id;
        setVariantId(def.id);
      }
    }
  }, [step, type, variantId]);
  function pickType(id) {
    setTypeId(id);
    setVariantId(null);
    setFabricId(null);
    setAccessories({});
    setAccLeatherColors({});
    setMainQty(1);
  }
  function pickVariant(id) {
    setVariantId(id);
    setFabricId(null);
    setAccessories({});
    setAccLeatherColors({});
    setMainQty(1);
  }
  function pickFabric(id) {
    setFabricId(id);
    setAccessories({});
    setAccLeatherColors({});
  }
  function setAccessoryQty(id, delta) {
    setAccessories(prev => {
      const current = prev[id] || 0;
      const next = Math.max(0, current + delta);
      if (next === 0) {
        const {
          [id]: _removed,
          ...rest
        } = prev;
        return rest;
      }
      return {
        ...prev,
        [id]: next
      };
    });
  }
  function changeMainQty(delta) {
    setMainQty(q => Math.max(1, q + delta));
  }
  const allStep5Items = useMemo(() => {
    if (!type || !variant || !fabric) return cart;
    return [...cart, {
      type,
      variant,
      fabric,
      accessories,
      mainQty,
      leatherColor: isLederFlow ? leatherColor : null,
      accLeatherColors
    }];
  }, [cart, type, variant, fabric, accessories, mainQty, isLederFlow, leatherColor, accLeatherColors]);
  const s5ActiveIdx = step5ActiveIdx ?? (allStep5Items.length > 0 ? allStep5Items.length - 1 : null);
  function updateItemMainQty(idx, delta) {
    const currentIdx = cart.length;
    if (idx === currentIdx) {
      setMainQty(q => Math.max(1, q + delta));
    } else {
      setCart(prev => {
        const next = [...prev];
        next[idx] = {
          ...next[idx],
          mainQty: Math.max(1, (next[idx].mainQty || 1) + delta)
        };
        return next;
      });
    }
  }
  function updateItemAccQty(idx, accId, delta) {
    const currentIdx = cart.length;
    const applyDelta = prev => {
      const cur = (prev || {})[accId] || 0;
      const nxt = Math.max(0, cur + delta);
      if (nxt === 0) {
        const {
          [accId]: _r,
          ...rest
        } = prev || {};
        return rest;
      }
      return {
        ...(prev || {}),
        [accId]: nxt
      };
    };
    if (idx === currentIdx) {
      setAccessories(applyDelta);
    } else {
      setCart(prev => {
        const next = [...prev];
        next[idx] = {
          ...next[idx],
          accessories: applyDelta(next[idx].accessories)
        };
        return next;
      });
    }
  }
  function deleteItem5(idx) {
    const currentIdx = cart.length;
    if (idx === currentIdx) {
      if (cart.length > 0) {
        const last = cart[cart.length - 1];
        setTypeId(last.type.id);
        setVariantId(last.variant.id);
        setFabricId(`fabric-${last.fabric.stoffcode}`);
        setAccessories({
          ...last.accessories
        });
        setAccLeatherColors({
          ...(last.accLeatherColors || {})
        });
        setMainQty(last.mainQty || 1);
        if (last.leatherColor?.id) setLeatherColorId(last.leatherColor.id);
        setCart(prev => prev.slice(0, -1));
        setStep5ActiveIdx(null);
      } else {
        setTypeId(null);
        setVariantId(null);
        setFabricId(null);
        setAccessories({});
        setAccLeatherColors({});
        setMainQty(1);
        setLeatherColorId('schwarz');
        setStep(1);
      }
    } else {
      setCart(prev => prev.filter((_, i) => i !== idx));
      setStep5ActiveIdx(null);
    }
  }
  function jumpTo(s) {
    if (s < step || s === step + 1 && canNext) setStep(s);
  }
  function addAnotherProduct() {
    if (type && variant && fabric) {
      setCart(prev => [...prev, {
        type,
        variant,
        fabric,
        accessories: {
          ...accessories
        },
        accLeatherColors: {
          ...accLeatherColors
        },
        mainQty,
        leatherColor: isLederFlow ? leatherColor : null
      }]);
    }
    setTypeId(null);
    setVariantId(null);
    setFabricId(null);
    setAccessories({});
    setAccLeatherColors({});
    setMainQty(1);
    setLeatherColorId('schwarz');
    setStep5ActiveIdx(null);
    setStep(1);
  }
  function startAnother(seedTypeId = null, seedVariantId = null) {
    if (type && variant && fabric) {
      setCart(prev => [...prev, {
        type,
        variant,
        fabric,
        accessories: {
          ...accessories
        },
        accLeatherColors: {
          ...accLeatherColors
        },
        mainQty,
        leatherColor: isLederFlow ? leatherColor : null
      }]);
    }
    setAccessories({});
    setAccLeatherColors({});
    setMainQty(1);
    setLeatherColorId('schwarz');
    setFabricId(null);
    setStep5ActiveIdx(null);
    if (seedTypeId && seedVariantId) {
      setTypeId(seedTypeId);
      setVariantId(seedVariantId);
      setStep(3);
    } else {
      setTypeId(null);
      setVariantId(null);
      setStep(1);
    }
    if (typeof window !== 'undefined') window.scrollTo?.({
      top: 0,
      behavior: 'smooth'
    });
  }
  async function handleSubmit() {
    if (!legalOk) return;
    const cfg = window.SHOPIFY_KONFIGURATOR || {};
    const allItems = [...cart, {
      type,
      variant,
      fabric,
      accessories,
      mainQty
    }];
    setSubmitting(true);
    try {
      const shopifyItems = [];
      const requestItems = [];
      for (const item of allItems) {
        const variantIdRaw = cfg.variantIds?.[`${item.type.id}:${item.variant.id}`] ?? cfg.variantIds?.[item.type.id];
        const variantIdNum = variantIdRaw ? Number(variantIdRaw) : null;
        const accParts = Object.entries(item.accessories || {}).filter(([, q]) => q > 0).map(([id, q]) => {
          const [tid, vid] = id.split(':');
          const t = PRODUCT_TYPES.find(x => x.id === tid);
          const v = t?.variants.find(x => x.id === vid);
          return v ? `${q}× ${t.label} ${v.label}` : id;
        });
        const prodImg = getProductImage(item.type.id, item.variant.id, item.fabric.stoffcode, item.leatherColor?.suffix);
        const lineProps = {
          'Ausführung': `${item.type.label} ${item.variant.label}`,
          'Stoff': item.fabric.stoffcode,
          'Hinweis': `Abbildung zeigt die Grundform — gefertigt wird Stoff ${item.fabric.stoffcode}`,
          '_produktbild': prodImg?.matched && prodImg.src || item.fabric.bild,
          '_stoffbild': item.fabric.bild
        };
        if (item.leatherColor) lineProps['Lederfarbe'] = item.leatherColor.label;
        if (accParts.length) lineProps['_begleiter'] = accParts.join(', ');
        lineProps['_widerrufsausschluss'] = 'Vom Kunden im Konfigurator bestätigt';
        if (variantIdNum) {
          shopifyItems.push({
            id: variantIdNum,
            quantity: item.mainQty || 1,
            properties: lineProps
          });
          for (const [accId, qty] of Object.entries(item.accessories || {})) {
            if (!qty) continue;
            const [accTypeId, accVarId] = accId.split(':');
            const accVariantIdRaw = cfg.variantIds?.[accId] ?? cfg.variantIds?.[accTypeId];
            if (accVariantIdRaw) {
              const accTypeObj = PRODUCT_TYPES.find(x => x.id === accTypeId);
              const accVariantObj = accTypeObj?.variants.find(v => v.id === accVarId);
              const accIsLeder = accTypeId === 'hosentraeger' && accVarId === 'leder';
              const accLederColor = accIsLeder ? (LEATHER_COLORS || []).find(c => c.id === ((item.accLeatherColors || {})[accId] || 'schwarz')) : null;
              const accImg = getProductImage(accTypeId, accVarId, item.fabric.stoffcode, accLederColor?.suffix);
              const accProps = {
                'Ausführung': `${accTypeObj?.label || accTypeId} ${accVariantObj?.label || accVarId}`,
                'Stoff': item.fabric.stoffcode,
                '_produktbild': accImg?.matched && accImg.src || item.fabric.bild,
                '_hauptprodukt': `${item.type.label} ${item.variant.label}`
              };
              if (accLederColor) accProps['Lederfarbe'] = accLederColor.label;
              shopifyItems.push({
                id: Number(accVariantIdRaw),
                quantity: qty,
                properties: accProps
              });
            }
          }
        } else {
          requestItems.push(item);
        }
      }
      if (shopifyItems.length > 0 && requestItems.length === 0) {
        const resp = await fetch(cfg.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: shopifyItems
          })
        });
        if (!resp.ok) {
          const errBody = await resp.text();
          console.error('[Konfigurator] cart/add fehlgeschlagen', resp.status, errBody);
          throw new Error(`Shopify-Warenkorb hat den Artikel abgelehnt (HTTP ${resp.status}).`);
        }
        document.dispatchEvent(new CustomEvent('konfigurator:cart-updated'));
        persistClear();
        const mode = cfg.redirectMode || 'cart';
        if (mode === 'checkout') {
          window.location.href = cfg.checkoutUrl || '/checkout';
        } else if (mode === 'cart') {
          window.location.href = cfg.cartUrl || '/cart';
        } else {
          setToast({
            message: 'In den Warenkorb gelegt',
            action: {
              label: 'Zum Warenkorb →',
              href: cfg.cartUrl || '/cart'
            }
          });
          const drawer = document.querySelector('[data-cart-drawer]');
          const overlay = document.querySelector('[data-overlay]');
          if (drawer) {
            drawer.classList.add('is-open');
            overlay && overlay.classList.add('is-active');
            document.body.style.overflow = 'hidden';
          }
        }
        return;
      }
      if (shopifyItems.length > 0) {
        await fetch(cfg.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: shopifyItems
          })
        });
        document.dispatchEvent(new CustomEvent('konfigurator:cart-updated'));
      }
      const itemsForRequest = requestItems.length > 0 ? requestItems : allItems;
      const noteLines = itemsForRequest.map((item, i) => {
        const accParts = Object.entries(item.accessories || {}).filter(([, q]) => q > 0).map(([id, q]) => {
          const [tid, vid] = id.split(':');
          const t = PRODUCT_TYPES.find(x => x.id === tid);
          const v = t?.variants.find(x => x.id === vid);
          return v ? `${q}× ${t.label} ${v.label}` : id;
        });
        return [`Artikel ${i + 1}: ${item.mainQty || 1}× ${item.type.label} ${item.variant.label}`, `Stoff: ${item.fabric.stoffcode}`, item.leatherColor ? `Lederfarbe: ${item.leatherColor.label}` : null, accParts.length ? `Begleiter: ${accParts.join(', ')}` : null].filter(Boolean).join('\n');
      }).join('\n\n');
      const formData = new FormData();
      formData.append('form_type', 'contact');
      formData.append('utf8', '✓');
      formData.append('contact[body]', noteLines);
      await fetch(cfg.contactFormAction || '/contact', {
        method: 'POST',
        body: formData
      });
      persistClear();
      setToast({
        message: 'Anfrage gesendet — wir melden uns bald!'
      });
    } catch (err) {
      console.error('[Konfigurator] Fehler beim Absenden:', err);
      setToast({
        message: 'Fehler beim Absenden. Bitte versuche es erneut.',
        variant: 'warn'
      });
    } finally {
      setSubmitting(false);
    }
  }
  const cfg = window.SHOPIFY_KONFIGURATOR || {};
  const _configuredItems = [...cart.map(c => ({
    t: c.type?.id,
    v: c.variant?.id
  })).filter(x => x.t), ...(typeId ? [{
    t: typeId,
    v: variantId
  }] : [])];
  const _resolveVid = (t, v) => cfg.variantIds?.[`${t}:${v}`] ?? cfg.variantIds?.[t];
  const _anyHasVariant = _configuredItems.some(({
    t,
    v
  }) => _resolveVid(t, v));
  const _allHaveVariant = _configuredItems.length > 0 && _configuredItems.every(({
    t,
    v
  }) => _resolveVid(t, v));
  let ctaLabel = 'Anfrage absenden';
  if (_allHaveVariant) ctaLabel = 'In den Warenkorb';else if (_anyHasVariant) ctaLabel = 'In den Warenkorb · Rest anfragen';
  const total = priceFor(typeId, accessories, mainQty, variantId);
  const cartTotal = cart.reduce((s, it) => s + priceFor(it.type.id, it.accessories, it.mainQty || 1, it.variant?.id), 0);
  const grandTotal = cartTotal + total;
  const accLines = Object.entries(accessories).filter(([, qty]) => qty > 0).map(([id, qty]) => {
    const [tid, vid] = id.split(':');
    const t = PRODUCT_TYPES.find(x => x.id === tid);
    const v = t?.variants.find(x => x.id === vid);
    const name = v ? `${t.label} ${v.label}` : id;
    return qty > 1 ? `${qty}× ${name}` : name;
  });
  const drawerPrice = step === summaryStep && s5ActiveIdx !== null && allStep5Items[s5ActiveIdx] ? `${fmtPrice(priceFor(allStep5Items[s5ActiveIdx].type.id, allStep5Items[s5ActiveIdx].accessories, allStep5Items[s5ActiveIdx].mainQty || 1, allStep5Items[s5ActiveIdx].variant?.id))} €` : grandTotal > 0 ? `${fmtPrice(grandTotal)} €` : `ab 19,95 €`;
  return React.createElement("div", {
    className: `cf ${isMobile ? 'cf--mobile' : 'cf--desktop'}`
  }, resumeDraft && React.createElement("div", {
    className: "cf-resume",
    role: "region",
    "aria-label": "Gespeicherte Konfiguration"
  }, React.createElement("span", {
    className: "cf-resume__icon",
    "aria-hidden": "true"
  }, "\u21BA"), React.createElement("span", {
    className: "cf-resume__text"
  }, "Du hast eine angefangene Konfiguration", (resumeDraft.cart || []).length > 0 ? ` mit ${(resumeDraft.cart || []).length + (resumeDraft.current?.typeId ? 1 : 0)} Artikeln` : '', "."), React.createElement("div", {
    className: "cf-resume__actions"
  }, React.createElement("button", {
    className: "cf-resume__btn cf-resume__btn--primary",
    onClick: applyResumeDraft
  }, "Fortsetzen"), React.createElement("button", {
    className: "cf-resume__btn",
    onClick: dismissResumeDraft
  }, "Neu starten"))), (() => {
    const selectedOnStep = step === 1 ? !!typeId : step === 2 ? !!variantId : step === 3 ? !!fabricId : isLederFlow && step === lederStep ? !!leatherColorId : false;
    const onLastStep = step === begleiterStep;
    const units = step - 1 + (selectedOnStep ? 1 : 0) + (onLastStep ? 0.5 : 0);
    const pct = Math.min(96, Math.round(10 + units / totalSteps * 86));
    return React.createElement("div", {
      className: "cf-nav"
    }, React.createElement("div", {
      className: "cf-nav__steps"
    }, STEP_LABELS.map((label, i) => {
      const n = i + 1;
      const filled = n < step && (n === 1 && typeId || n === 2 && variantId || n === 3 && fabricId || n === lederStep && leatherColorId || n === begleiterStep);
      const active = n === step;
      const reachable = n <= step || n === step + 1 && canNext;
      return React.createElement(React.Fragment, {
        key: n
      }, i > 0 && React.createElement("span", {
        className: `cf-nav__link${n <= step ? ' is-past' : ''}`,
        "aria-hidden": "true"
      }), React.createElement("button", {
        className: `cf-nav__step${active ? ' is-active' : ''}${filled ? ' is-done' : ''}`,
        onClick: () => reachable && jumpTo(n),
        disabled: !reachable,
        "aria-current": active ? 'step' : undefined
      }, React.createElement("span", {
        className: "cf-nav__circle"
      }, filled ? React.createElement("svg", {
        key: "check",
        className: "cf-nav__check",
        viewBox: "0 0 16 16",
        "aria-hidden": "true"
      }, React.createElement("path", {
        d: "M3.5 8.5l3 3 6-6.5",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })) : React.createElement("em", null, n)), React.createElement("span", {
        className: "cf-nav__label"
      }, label)));
    })), React.createElement("div", {
      className: "cf-progress"
    }, React.createElement("div", {
      className: "cf-progress__bar",
      role: "progressbar",
      "aria-valuenow": pct,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }, React.createElement("span", {
      className: "cf-progress__fill",
      style: {
        width: pct + '%'
      }
    }, React.createElement(AnimatedPct, {
      value: pct
    })))));
  })(), React.createElement("div", {
    className: "cf-body"
  }, React.createElement("main", {
    className: "cf-main"
  }, step === 1 && React.createElement(StepProduct, {
    typeId: typeId,
    onPick: pickType
  }), step === 2 && React.createElement(StepVariant, {
    type: type,
    variantId: variantId,
    onPick: pickVariant
  }), step === 3 && React.createElement(StepFabric, {
    type: type,
    variant: variant,
    fabric: fabric,
    fabricId: fabricId,
    onPick: pickFabric,
    pinned: pinned,
    onTogglePin: togglePin,
    onOpenCompare: () => setCompareOpen(true),
    leatherColorSuffix: isLederFlow ? leatherSuffix : null
  }), step === lederStep && React.createElement(StepLederColor, {
    type: type,
    variant: variant,
    fabric: fabric,
    leatherColorId: leatherColorId,
    onPick: setLeatherColorId
  }), step === begleiterStep && React.createElement(StepBegleiter, {
    type: type,
    variant: variant,
    fabric: fabric,
    accessories: accessories,
    onSetQty: setAccessoryQty,
    mainQty: mainQty,
    onSetMainQty: changeMainQty,
    leatherColorSuffix: isLederFlow ? leatherSuffix : null,
    accLeatherColors: accLeatherColors,
    onSetAccLeatherColor: setAccessoryLeatherColor,
    legalOk: legalOk,
    onLegalOk: setLegalOk,
    onAddSameModel: () => startAnother(type?.id, variant?.id),
    onAddOther: () => startAnother(),
    onCompanionOtherFabric: (pt, pv) => startAnother(pt.id, pv.id)
  }), step === summaryStep && React.createElement(StepSummary, {
    allItems: allStep5Items,
    activeIdx: s5ActiveIdx,
    onSelect: setStep5ActiveIdx,
    onDelete: deleteItem5,
    onAddAnother: addAnotherProduct
  })), isMobile && drawerOpen && React.createElement("div", {
    className: "cf-drawer-backdrop",
    onClick: () => setDrawerOpen(false),
    "aria-hidden": "true"
  }), React.createElement("aside", {
    className: `cf-rail cf-rail--summary${drawerOpen ? ' is-open' : ''}`
  }, React.createElement("button", {
    className: "cf-drawer-handle",
    onClick: () => setDrawerOpen(o => !o),
    "aria-expanded": drawerOpen,
    "aria-label": "Zusammenfassung anzeigen"
  }, React.createElement("span", null, "Zusammenfassung"), React.createElement("span", {
    className: "cf-drawer-handle__price"
  }, drawerPrice), React.createElement("span", {
    className: "cf-drawer-handle__caret"
  }, "\u25B4")), React.createElement("div", {
    className: "cf-rail-eyebrow"
  }, "Deine Konfiguration"), step !== summaryStep && cart.length > 0 && React.createElement("div", {
    className: "cf-rail-added"
  }, React.createElement("div", {
    className: "cf-rail-added-head"
  }, "Schon hinzugef\xFCgt (", cart.length, ")"), cart.map((it, i) => React.createElement("div", {
    key: i,
    className: "cf-rail-added-row"
  }, it.fabric?.bild && React.createElement("img", {
    src: it.fabric.bild,
    alt: "",
    className: "cf-rail-added-sw"
  }), React.createElement("span", {
    className: "cf-rail-added-name"
  }, it.type.label, " ", it.variant.label, React.createElement("em", null, "Stoff ", it.fabric?.stoffcode)), React.createElement("span", {
    className: "cf-rail-added-price"
  }, fmtPrice(priceFor(it.type.id, it.accessories, it.mainQty || 1, it.variant?.id)), " \u20AC"), React.createElement("button", {
    type: "button",
    className: "cf-rail-added-del",
    onClick: () => setCart(prev => prev.filter((_, x) => x !== i)),
    "aria-label": "St\xFCck entfernen",
    title: "Entfernen"
  }, "\xD7"))), React.createElement("div", {
    className: "cf-rail-added-current"
  }, "Aktuelles St\xFCck")), step === summaryStep && s5ActiveIdx !== null && allStep5Items[s5ActiveIdx] ? (() => {
    const sel = allStep5Items[s5ActiveIdx];
    const selAccEntries = Object.entries(sel.accessories || {}).filter(([, q]) => q > 0);
    return React.createElement("div", {
      className: "cf-s5rail"
    }, React.createElement("div", {
      className: "cf-s5rail-head"
    }, "Produkt"), React.createElement("div", {
      className: "cf-s5rail-val"
    }, sel.type.label, " ", sel.variant.label), React.createElement("div", {
      className: "cf-s5rail-sub"
    }, sel.variant.desc), React.createElement("div", {
      className: "cf-s5rail-head"
    }, "Stoff"), React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 2
      }
    }, React.createElement("img", {
      src: sel.fabric.bild,
      alt: "",
      style: {
        width: 28,
        height: 20,
        border: '1px solid var(--line-mid)',
        flexShrink: 0
      }
    }), React.createElement("div", {
      className: "cf-s5rail-val",
      style: {
        marginBottom: 0
      }
    }, sel.fabric.stoffcode)), fabricSubLabel(sel.fabric) && React.createElement("div", {
      className: "cf-s5rail-sub"
    }, fabricSubLabel(sel.fabric)), React.createElement("div", {
      className: "cf-s5rail-div"
    }), React.createElement("div", {
      className: "cf-s5rail-row"
    }, React.createElement("span", {
      className: "cf-s5rail-label"
    }, "St\xFCckzahl"), React.createElement("div", {
      className: "cf-qty"
    }, React.createElement("button", {
      className: "cf-qty-btn",
      onClick: () => updateItemMainQty(s5ActiveIdx, -1),
      disabled: (sel.mainQty || 1) <= 1
    }, "\u2212"), React.createElement("span", {
      className: "cf-qty-val"
    }, sel.mainQty || 1), React.createElement("button", {
      className: "cf-qty-btn",
      onClick: () => updateItemMainQty(s5ActiveIdx, +1)
    }, "+"))), selAccEntries.length > 0 && React.createElement(React.Fragment, null, React.createElement("div", {
      className: "cf-s5rail-div"
    }), React.createElement("div", {
      className: "cf-s5rail-head",
      style: {
        marginBottom: 8
      }
    }, "Begleiter"), React.createElement("div", {
      className: "cf-s5rail-acc-list"
    }, selAccEntries.map(([accId, qty]) => {
      const [tid, vid] = accId.split(':');
      const at = PRODUCT_TYPES.find(x => x.id === tid);
      const av = at?.variants.find(x => x.id === vid);
      const name = av ? `${at.label} ${av.label}` : accId;
      return React.createElement("div", {
        key: accId,
        className: "cf-s5rail-acc-row"
      }, React.createElement("div", {
        className: "cf-qty"
      }, React.createElement("button", {
        className: "cf-qty-btn",
        onClick: () => updateItemAccQty(s5ActiveIdx, accId, -1)
      }, "\u2212"), React.createElement("span", {
        className: "cf-qty-val"
      }, qty), React.createElement("button", {
        className: "cf-qty-btn",
        onClick: () => updateItemAccQty(s5ActiveIdx, accId, +1)
      }, "+")), React.createElement("span", {
        className: "cf-s5rail-acc-name"
      }, name));
    }))));
  })() : React.createElement("div", {
    className: "cf-sum"
  }, React.createElement(SumRow, {
    label: "Produkt",
    value: type?.label,
    empty: "Noch nicht gew\xE4hlt",
    onEdit: step > 1 ? () => setStep(1) : null
  }), React.createElement(SumRow, {
    label: "Ausf\xFChrung",
    value: variant?.label,
    sub: variant?.desc,
    empty: "Noch nicht gew\xE4hlt",
    onEdit: step > 2 ? () => setStep(2) : null
  }), React.createElement(SumRow, {
    label: "Stoff",
    value: fabric ? `${fabric.stoffcode}` : null,
    sub: fabricSubLabel(fabric),
    swatch: fabric?.bild,
    empty: "Noch nicht gew\xE4hlt",
    onEdit: step > 3 ? () => setStep(3) : null
  }), isLederFlow && fabric && leatherColor && React.createElement(SumRow, {
    label: "Lederfarbe",
    value: leatherColor.label,
    swatch: leatherColor.swatch,
    empty: "\u2014",
    onEdit: lederStep && step > lederStep ? () => setStep(lederStep) : null
  }), React.createElement("div", {
    className: "cf-sum-row is-small"
  }, React.createElement("div", {
    className: "cf-sum-label"
  }, "Begleiter"), React.createElement("div", {
    className: "cf-sum-value"
  }, accLines.length > 0 ? React.createElement("div", {
    className: "cf-sum-acc-list"
  }, accLines.map((line, i) => React.createElement("div", {
    key: i,
    className: "cf-sum-acc-line"
  }, line))) : React.createElement("span", null, "\u2014")))), step === begleiterStep && React.createElement("label", {
    className: `cf-legal-check cf-legal-check--rail${legalOk ? ' is-checked' : ''}`
  }, React.createElement("input", {
    type: "checkbox",
    checked: legalOk,
    onChange: e => setLegalOk(e.target.checked)
  }), React.createElement("span", null, "Mir ist bekannt, dass individuell angefertigte Manufaktur-Produkte vom gesetzlichen Widerrufsrecht ausgeschlossen sind (\xA7 312g Abs. 2 Nr. 1 BGB).")), React.createElement("div", {
    className: "cf-price"
  }, React.createElement("span", {
    className: "cf-price-label"
  }, "Preis"), React.createElement("span", {
    className: "cf-price-value"
  }, step === summaryStep && s5ActiveIdx !== null && allStep5Items[s5ActiveIdx] ? `${fmtPrice(priceFor(allStep5Items[s5ActiveIdx].type.id, allStep5Items[s5ActiveIdx].accessories, allStep5Items[s5ActiveIdx].mainQty || 1, allStep5Items[s5ActiveIdx].variant?.id))} €` : grandTotal > 0 ? `${fmtPrice(grandTotal)} €` : `ab 19,95 €`)), React.createElement("div", {
    className: "cf-rail-spacer"
  }))), React.createElement("footer", {
    className: "cf-foot"
  }, React.createElement("button", {
    className: "cf-back",
    onClick: () => step > 1 && setStep(step - 1),
    disabled: step === 1
  }, "\u2190 Zur\xFCck"), React.createElement("div", {
    className: "cf-foot-center"
  }, isMobile && React.createElement("span", {
    className: "cf-foot-price"
  }, drawerPrice)), step < begleiterStep ? React.createElement("button", {
    className: "cf-next",
    onClick: () => canNext && setStep(step + 1),
    disabled: !canNext
  }, "Weiter ", React.createElement("span", {
    className: "cf-arrow"
  }, "\u2192")) : React.createElement("button", {
    className: "cf-next cf-next--cta",
    onClick: handleSubmit,
    disabled: submitting || !legalOk,
    title: legalOk ? undefined : 'Bitte zuerst den Hinweis zum Widerrufsausschluss bestätigen'
  }, submitting ? 'Wird gesendet …' : ctaLabel, " ", React.createElement("span", {
    className: "cf-arrow"
  }, "\u2192"))), compareOpen && type && variant && pinned.length > 0 && React.createElement(CompareModal, {
    type: type,
    variant: variant,
    fabricId: fabricId,
    pinnedFabrics: pinned.map(id => FABRICS.find(f => f.id === id)).filter(Boolean),
    onPick: id => {
      pickFabric(id);
      setCompareOpen(false);
    },
    onUnpin: unpin,
    onClose: () => setCompareOpen(false),
    leatherColorSuffix: isLederFlow ? leatherSuffix : null
  }), toast && React.createElement(Toast, {
    message: toast.message,
    variant: toast.variant,
    action: toast.action,
    onDone: () => setToast(null)
  }));
}
Object.assign(window, {
  ConfiguratorApp
});
